// import { Routes, Route } from "react-router-dom";


// import Home from "./Components/Home";
// import About from "./Components/About";


// import Ourproduct from "./Components/Ourproduct";
// import ContactUs from "./Components/ContactUs";

// function App() {
//   return (
//     <>
 

//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/product" element={<Ourproduct />} />
//         <Route path="/contact" element={<ContactUs />} />
//       </Routes>
//     </>
//   );
// }

// export default App;






import { Routes, Route } from "react-router-dom";

import About from "./Components/About";
import ContactUs from "./Components/ContactUs";
import Ourproduct from "./Components/Ourproduct";
import Home from"./Components/Home"


function App() {
  return (
    <>
    
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About />} />
        <Route path="/product" element={<Ourproduct />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
    
    </>
  );
}

export default App;
